import { render, staticRenderFns } from "./BecomeABrokerPopup.vue?vue&type=template&id=51061b92&scoped=true"
import script from "./BecomeABrokerPopup.vue?vue&type=script&lang=js"
export * from "./BecomeABrokerPopup.vue?vue&type=script&lang=js"
import style0 from "./BecomeABrokerPopup.vue?vue&type=style&index=0&id=51061b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51061b92",
  null
  
)

export default component.exports